import React from 'react';
import URL from 'js-handy-url';
import Image from '../view/components/Image.jsx';

export default class ShoppingList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            playing : false,
        };

        this.src = null;
    }

    componentWillMount () {
        // component init
        this.src = ( new URL(this.props.src.toString()) ).addParameter('autoplay', '1');
    }

    play () {
        if (! this.state.playing) {
            this.setState({playing: true});
        }
    }

    render () {
        if (! this.state.playing) {
            return <div className="layer" onClick={ this.play.bind(this) }>
                <Image src={this.props.placeholder_image.src} />
                <div className="icon-video"></div>
            </div>;
        } else {
            return <iframe className="layer" src={ this.src.toString() } frameBorder="0" allowFullScreen></iframe>
        }
    }
};
